// /components/simulator/charts/TraditionalRentalYearlyChart.jsx

import React from 'react';
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString()}`;
};

const formatShortCurrency = (val) => {
  if (val >= 1_000_000) return `$${(val / 1_000_000).toFixed(2)}M`;
  if (val >= 1_000) return `$${(val / 1_000).toFixed(0)}K`;
  return `$${Math.round(val)}`;
};

const TraditionalRentalYearlyChart = ({ yearlyData, investorResult }) => {
  if (!yearlyData || yearlyData.length === 0) {
    return <div className="text-center text-gray-500">No data available for chart.</div>;
  }

  const lastYear = yearlyData[yearlyData.length - 1];

  return (
    <div className="bg-white shadow-md rounded-lg p-6 mt-8">
      <h2 className="text-xl font-bold text-center text-blue-700 mb-6">
        Full Financial Journey - Detailed Stacking
      </h2>

      <ResponsiveContainer width="100%" height={550}>
        <ComposedChart
          data={yearlyData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis tickFormatter={(value) => `$${value / 1000}k`} />
          <Tooltip formatter={(value) => formatCurrency(value)} />
          <Legend />

          {/* Stacked Bars */}
          <Bar dataKey="cumulativeNetIncome" stackId="wealth" fill="#60a5fa" name="Net Income" />
          <Bar dataKey="cumulativeVacancyLoss" stackId="wealth" fill="#f87171" name="Vacancy Loss" />
          <Bar dataKey="cumulativeMaintenance" stackId="wealth" fill="#fbbf24" name="Maintenance Paid" />
          <Bar dataKey="cumulativeTax" stackId="wealth" fill="#facc15" name="Tax Paid" />
          <Bar dataKey="cumulativeInsurance" stackId="wealth" fill="#34d399" name="Insurance Paid" />
          <Bar dataKey="cumulativeAdminFees" stackId="wealth" fill="#c084fc" name="Admin Fee Paid" />
          {/* <Bar dataKey="netCashflowYearly" stackId="wealth" fill="#4ade80" name="Net Cashflow" />
          <Bar dataKey="equityGrowth" stackId="wealth" fill="#818cf8" name="Equity Growth" /> */}
          

          {/* Net Worth Line */}

          <Line
            type="monotone"
            dataKey="exitValueLine"
            stroke="#6366f1"
            strokeWidth={3}
            dot={{ r: 3 }}
            name="Investor Exit Value"
          >
            <LabelList
              dataKey="exitValueLine"
              position="top"
              content={({ x, y, value, index }) => {
                if (index === yearlyData.length - 1) {
                  return (
                    <text x={x} y={y - 10} textAnchor="middle" fill="red" fontWeight="bold">
                      Exit: {formatShortCurrency(value)}
                    </text>
                  );
                }
                return null;
              }}
            />
          </Line>

          <Line type="monotone" dataKey="assetValue" stroke="#0f172a" strokeWidth={2} name="Asset Value">  <LabelList
            dataKey="assetValue"
            position="top"
            content={({ x, y, value, index }) =>
              index === yearlyData.length - 1 ? (
                <text x={x - 6} y={y - 14} fill="#0f172a" textAnchor="middle" fontSize={12} fontWeight="bold">
                  Asset: {formatShortCurrency(value)}
                </text>
              ) : null
            }
          />
          </Line>

        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TraditionalRentalYearlyChart;
